import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GameDetailsContent } from '../GameDetailsPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';
import { GameType } from '../../../components/Games/games.model';

type RouteParams = {
  brand?: string;
};

export const ItvBingoDetailsPage: FC = () => {
  const { brand } = useParams<RouteParams>();
  const { setTheme } = useUserContext();

  useEffect(() => {
    if (brand === BRANDS.BINGO || brand === BRANDS.SPINS) {
      setTheme(brand);
    }
  }, [brand, setTheme]);

  return <GameDetailsContent gameType={GameType.Bingo} />;
};
